module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-12-5b5d0b72c150c2d1176841a0f13375ba.svg";